import { Box, Theme } from '@mui/material'
import { Link } from 'react-router'
import appStoreDownload from '~/assets/images/appStoreDownload.png'

const AppStoreButton = (props: { height?: number }) => {
  const height = props.height || 10

  return <Link to='https://apps.apple.com/gb/app/solo-booking-software/id1496933554' target='_blank' rel='noreferrer'>
    <Box
      component='img'
      src={appStoreDownload}
      alt='app-store-download'
      sx={{
        height: (theme: Theme) => theme.spacing(height),
      }}
    />
  </Link>
}

export default AppStoreButton
